var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-builder-layout-placeholder-notepad" },
    _vm._l(_vm.PLACEHOLDER_SAMPLES, function (i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "layout-builder-layout-placeholder-notepad-item",
        },
        [_vm._m(0, true), _vm._v(" "), _vm._m(1, true)]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "layout-builder-layout-placeholder-notepad-item-top" },
      [
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-notepad-item-top-line",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-notepad-item-top-square",
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "layout-builder-layout-placeholder-notepad-item-bottom" },
      [
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-notepad-item-bottom-line",
        }),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "layout-builder-layout-placeholder-notepad-item-bottom-square",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }